import { Box } from '@gousto-internal/citrus-react'
import React from 'react'
import { BrandEndorsementsSection } from './components/BrandEndorsementsSection/BrandEndorsementsSection'

export function LandingPageContent() {
  return (
    <Box data-testid="landing-page-content">
      <BrandEndorsementsSection />
    </Box>
  )
}
